export default __webpack_public_path__ + "static/media/LoginBackground.745f023c.png";